import { render, staticRenderFns } from "./Jibri.vue?vue&type=template&id=5bc1edb0"
import script from "./Jibri.vue?vue&type=script&lang=js"
export * from "./Jibri.vue?vue&type=script&lang=js"
import style0 from "./Jibri.vue?vue&type=style&index=0&id=5bc1edb0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc1edb0')) {
      api.createRecord('5bc1edb0', component.options)
    } else {
      api.reload('5bc1edb0', component.options)
    }
    module.hot.accept("./Jibri.vue?vue&type=template&id=5bc1edb0", function () {
      api.rerender('5bc1edb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Jibri.vue"
export default component.exports